export default "__VITE_ASSET__826d5fa3__"